import { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userContext } from "../../../contextAdmin/Admin/User/index";
import { HeaderTextContext } from "../../../contextAdmin/hederText";
import "./style.css";
import React from "react";
import polygon from "../../../assets/images/icons/polygon.svg"
import { studentDataContext } from "../../../contextAdmin/Admin/StudentData/index";
import Graphs from "../../../components/Admin/RowExtension/Graphs/Graphs";
// import Graph from "../../../components/Admin/GraphDashboard/Graph";

// import assessment graph component

// import TF graph component
// import TR graph component

// Creator : Team E - Ariel
export default function StudentDetails(props) {
  const { user } = useContext(userContext);
  const NoPermission = useNavigate();
  const { hederText, setHeaderText } = useContext(HeaderTextContext);
  const { setstudentData, studentData, classData, setClassData } = useContext(studentDataContext)
  console.log("🚀 ~ file: StudentDetails.js:23 ~ StudentDetails ~ studentData:", studentData)
  const [fullName, setFullName] = useState("")
  const [isRotated, setIsRotated] = useState("");
  const [lastWPM, setLastWPM] = useState("");
  const toggleRotation = (id) => {
    if (id == isRotated) {
      setIsRotated("")
    } else {
      setIsRotated(id);
    }
  };
  //   const { firstName, lastName, TR, TF, assessment } = props;
  const allActivities = [...studentData.assessments, ...studentData.TR, ...studentData.TF];
  const lastActivity = {
    assessments: studentData.assessments.length ? studentData.assessments[studentData.assessments.length - 1] : { date: "--/--/--", value: "No data yet" },
    TR: studentData.TR.length ? studentData.TR[studentData.TR.length - 1] : { date: "--/--/--", value: "No data yet" },
    TF: studentData.TF.length ? studentData.TF[studentData.TF.length - 1] : { date: "--/--/--", value: "No data yet" },
  }


  useEffect(() => {

    setHeaderText(<><Link className="header-title-gray" to={`/students/${studentData.classId}`} state={classData}>Classroom #{studentData.classId}{" "}</Link>/Student Details</>);
    const sort = allActivities.length ? allActivities.sort((a, b) => {
      return new Date(a.date).getTime() - new Date(b.date).getTime();
    }) : [];
    setFullName(studentData.firstName + " " + studentData.lastName)
    console.log("sort", sort);
  }, []);

  return (


    <div className="student-container">
      <div className="student-name-container">
        Student Name
        <div className="student-name">
          {fullName}
        </div>
      </div>
      <div className="graphs">

        <Graphs userDetails={studentData} setLastWPM={setLastWPM} />
      </div>
      <div style={{ margin: "1.2rem auto", width: '100%', height: '100%', border: '0.50px #CDB6B1 solid' }}></div>
      {
        studentData.assessments.length ?
          <div className="assessment block-data">
            <div>{formatDate(lastActivity.assessments.date)}</div>
            <div>WEEKLY MEASUREMENT</div>
            <div>{lastWPM + " WPM"}</div>
            <div></div>
          </div>
          : null
      }
      {
        studentData.TF.length ?
          <div className="train-focus block-data">
            <div>{formatDate(lastActivity.TF.date)}</div>
            <div>NEAR POINT</div>
            <div>{lastActivity.TF.value.toFixed(2) + " CM"}</div>
            <div></div>
          </div>
          : null
      }
      {studentData.TR.length ? studentData.TR.map(tr => (

        <div key={tr.date} className="train-reading" onClick={() => toggleRotation(tr.date)}>
          <div className="block-data">
            <div>{formatDate(tr.date)}</div>
            <div>PUSHUP</div>
            <div>{tr.value + " LPM"}</div>
            <div className={`image-container ${isRotated == tr.date ? 'rotate' : ''}`} >
              <img src={polygon} alt="Polygon" />
            </div>
          </div>
          {isRotated == tr.date ? <TrainReadindDetails answers={tr.answers} /> : ""}
        </div>
      )) : null}
    </div>
    // {/* <img className="imgraf" src={require("./graf.png")} /> */ }

  );
}
function formatDate(date, TZ = "USA") {
  if (isTimeZoneFormatDate(date)) {

    const originalDate = new Date(date);

    // Format into DD/MM/YYYY
    const dd = String(originalDate.getUTCDate()).padStart(2, '0');
    const mm = String(originalDate.getUTCMonth() + 1).padStart(2, '0'); // Month is zero-based
    const yyyy = originalDate.getUTCFullYear();
    const formattedDateDDMMYYYY = `${dd}/${mm}/${yyyy}`;

    // Format into MM/DD/YYYY
    const mm2 = String(originalDate.getUTCMonth() + 1).padStart(2, '0'); // Month is zero-based
    const dd2 = String(originalDate.getUTCDate()).padStart(2, '0');
    const formattedDateMMDDYYYY = `${mm2}/${dd2}/${yyyy}`;

    return TZ == "USA" ? formattedDateMMDDYYYY : formattedDateDDMMYYYY;
  }

}


function isTimeZoneFormatDate(str) {
  const timestamp = Date.parse(str);
  return !isNaN(timestamp); // Returns true if parsing succeeded
}


function ActivityByDate({ details }) {
  return (
    <>
      {
        <div
          className={
            "activityByDate"
            // (details === "assessment" &&
            //     "activityByDate::assessment") ||
            // (details === "TF" && "activityByDate::activityByDate-TF") ||
            // (details === "TR" && "activityByDate::activityByDate-TR")
          }
        >
          <div className="date">4/4/4</div>
          <div className="activity">tf</div>
          <div className="result">55</div>
          {details === "TR" && <div></div>}
        </div>
      }
    </>
  );
}


function TrainReadindDetails({ answers }) {
  const [data, setData] = useState([...answers.level, ...answers.pushUp])
  console.log("🚀 ~ file: StudentDetails.js:147 ~ TrainReadindDetails ~ data:", data)
  return (

    data.map((answers, i) => (
      <div className="train-readind-details">
        <div className="answer">
          {i == 0 && <div className="answer-headline">Who</div>}
          <div className="ans-content">{answers["1"]}</div>

        </div>
        <div className="answer">
          {i == 0 && <div className="answer-headline">What</div>}
          <div className="ans-content">{answers["2"]}</div>

        </div>
        <div className="answer">
          {i == 0 && <div className="answer-headline">When</div>}
          <div className="ans-content">{answers["3"]}</div>

        </div>
        <div className="answer">
          {i == 0 && <div className="answer-headline">Where</div>}
          <div className="ans-content">{answers["4"]}</div>
        </div>
      </div>))

  )
}